import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {FuseLoadingBarComponent} from '@fuse/components/loading-bar/loading-bar.component';
import {NgxSpinnerModule} from "ngx-spinner";

@NgModule({
    declarations: [
        FuseLoadingBarComponent
    ],
    imports: [
        CommonModule,
        NgxSpinnerModule,
        MatProgressBarModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],

    exports: [
        FuseLoadingBarComponent
    ]
})
export class FuseLoadingBarModule {
}
